<div [style.width]="width" id="Tab">
  <mat-tab-group
    (selectedTabChange)="tabChanged($event)"
    [selectedIndex]="selectedIndex"
  >
    <mat-tab [label]="label" *ngFor="let label of labels"></mat-tab>
  </mat-tab-group>
</div>
